function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { APP_INIT_RECEIVE, APP_INIT_REQUEST, APP_URL_INIT } from 'moduleBase/constants';
import { of } from 'rxjs/internal/observable/of';
import { from } from 'rxjs/internal/observable/from';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { catchError } from 'rxjs/internal/operators/catchError';
import { getLangFromPathname, setLangToPathname } from 'srcJs/helpers/LanguageHelper';
import { featureToggle } from '@collaborator/npm_modules/dist/components/featureToggle';
import realtimeNotification from 'srcJs/components/realtime-notification/realtime-notification';
export var appInit = function appInit() {
  return function (dispatch, getState, _ref) {
    var networkService = _ref.networkService,
        history = _ref.history,
        app = _ref.app;
    dispatch({
      type: APP_INIT_REQUEST
    });
    app.setLang(getLangFromPathname(history.location.pathname));
    networkService.setLang(app.getLang());
    var translate = app.getTranslate();
    var initObservable = from(networkService.get(APP_URL_INIT));
    var translateObservable = from(translate.load()).pipe(catchError(function (error) {
      return of(error);
    }));
    return new Promise(function (resolve) {
      forkJoin([initObservable, translateObservable]).subscribe(function (result) {
        var initResult = result[0];
        app.getUser().setData(initResult.data.user);
        app.setLang(initResult.data.languageSettings.current);
        app.getExternalApp().setList(initResult.data.externalApps);
        featureToggle.addFeatures(initResult.data.features);
        featureToggle.parseCookie();

        if (!realtimeNotification.isConnected()) {
          realtimeNotification.reconnect({
            userId: initResult.data.user.id
          });
        }

        var pathname = setLangToPathname(window.location.pathname, app.getLang());

        if (history.location.pathname !== pathname) {
          history.replace(pathname);
          dispatch(appInit());
          return;
        }

        dispatch({
          type: APP_INIT_RECEIVE,
          payload: _objectSpread({
            isInit: true
          }, initResult.data)
        });
        resolve(initResult.data);
      }, function (error) {
        return Promise.reject(error);
      });
    });
  };
};